import styled from '@emotion/styled';
import {
  FixedValue,
  MultiLineTextValue,
  PositiveIntegerValue,
  SingleLineTextValue,
} from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionFieldInterface } from '../../../../../generated/graphql';
import LfToBr from '../../../primitive/LfToBr';
import Linkify from '../../../primitive/Linkify';
import _RouterLink from '../../../primitive/RouterLink';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionFieldInterface, 'label' | 'type'>;
  value: SingleLineTextValue | MultiLineTextValue | PositiveIntegerValue | FixedValue;
  latestValue: SingleLineTextValue | MultiLineTextValue | PositiveIntegerValue | FixedValue;
  beforeValue: SingleLineTextValue | MultiLineTextValue | PositiveIntegerValue | FixedValue;
  className?: string;
}

const AsPlainText = ({ field, latestValue, beforeValue, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      {latestValue === beforeValue ? (
        !latestValue ? (
          <Value>
            <FormattedMessage id={'creative_brief_detail.field.empty'} />
          </Value>
        ) : (
          <Value>
            <LfToBr text={`${latestValue}`}>
              {(line, key) => (
                <Linkify text={line} key={key}>
                  {(url, key) => (
                    <RouterLink href={url} withNewTab key={key}>
                      {url}
                    </RouterLink>
                  )}
                </Linkify>
              )}
            </LfToBr>
          </Value>
        )
      ) : (
        <>
          <BeforeValue>
            <LfToBr text={`${beforeValue ? beforeValue : '　'}`}>
              {(line, key) => (
                <Linkify text={line} key={key}>
                  {(url, key) => (
                    <RouterLink href={url} withNewTab key={key}>
                      {url}
                    </RouterLink>
                  )}
                </Linkify>
              )}
            </LfToBr>
          </BeforeValue>
          <AfterValue>
            <LfToBr text={`${latestValue ? latestValue : '　'}`}>
              {(line, key) => (
                <Linkify text={line} key={key}>
                  {(url, key) => (
                    <RouterLink href={url} withNewTab key={key}>
                      {url}
                    </RouterLink>
                  )}
                </Linkify>
              )}
            </LfToBr>
          </AfterValue>
        </>
      )}
    </Base>
  );
};

const Value = styled(Typography)({
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
});

const BeforeValue = styled(Typography)({
  padding: '4px',
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
  background: '#fdd7d5',
  marginBottom: '8px',
});

const AfterValue = styled(Typography)({
  padding: '4px',
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
  background: '#c8ffd8',
});

const RouterLink = styled(_RouterLink)({ display: 'inline' });

export default AsPlainText;
